module.exports = __webpack_public_path__ + "static/media/logoMobileWellness.9b82af47.svg";